import dayjs from "dayjs";
import utc from "dayjs-plugin-utc";
import { useState } from "react";
import useDocumentTitle from "../../utils/useDocumentTitle";

import styles from "./Teams.module.scss";

import { Metric, MetricsWrapper } from "../../components/Metric";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import { Tab, Tabs } from "../../components/Tabs";
import { TableConfig } from "../../config/Config";
import { DashboardLayout } from "../../layouts/DashboardLayout";

import { useTranslation } from "react-i18next";
import { useCampaign } from "../../context/campaign";
import CampaignTable from "./CampaignTable";

dayjs.extend(utc);

export function TeamCampaign(props) {
  const { t } = useTranslation();
  useDocumentTitle(props.title);
  const { selectedCampaign } = useCampaign();

  const [perPage, setPerPage] = useState(TableConfig.resultPerPage);

  const tableHeader = [
    { name: "coach", label: t("teams.coach"), width: "15%" },
    { name: "employee_id", label: t("teams.employeeId"), width: "5%" },
    { name: "department", label: t("teams.department"), width: "15%" },
    { name: "sub_functional_unit", label: t("teams.subunit"), width: "20%" },
    { name: "last_session", label: t("teams.lastSession"), width: "10%" },
    {
      name: "upcoming_session",
      label: t("teams.upcommingSession"),
      width: "15%",
    },
    { name: "total_coachees", label: t("teams.totalCoachees"), width: "15%" },
  ];
  //ascending
  //descending

  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <SectionTitle>{t("teams.teams")}</SectionTitle>

            <Tabs>
              <Tab
                label={"Functional Unit"}
                tabName={t("tabs.campaign")}
                defaultTab={true}
              />
              <Tab label={"team"} tabName={t("tabs.team")} linkTo={`/teams`} />
            </Tabs>
            {selectedCampaign && (
              <MetricsWrapper>
                <Metric
                  label={t("teams.coach")}
                  api="getCampaignTotalCoaches"
                  responseKey="response.data.data.totalCoaches"
                  isCampaign={selectedCampaign}
                />
                <Metric
                  label={t("teams.taggedCoaches")}
                  api="getCampaignTotalCoachees"
                  responseKey="response.data.data.assignedCoachees"
                  isCampaign={selectedCampaign}
                />
                <Metric
                  label={t("teams.untaggedCoachees")}
                  api="getCampaignTotalCoachees"
                  responseKey="response.data.data.unAssignedCoachees"
                  isCampaign={selectedCampaign}
                />
              </MetricsWrapper>
            )}
            {selectedCampaign && (
              <CampaignTable
                selectedCampaign={selectedCampaign}
                tableHeader={tableHeader}
                isPersonal={false}
                perPage={perPage}
                setPerPage={setPerPage}
              />
            )}
          </Section>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
